export default "__VITE_PUBLIC_ASSET__16062adf__"